import { z } from 'zod'

import { DAY_MS, utcDay } from '@/utils/dates'

const isValidDay = (value: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && utcDay(Date.parse(value)) === value
const daySchema = z.string().refine(isValidDay, 'Choose a valid date.')
export const dateWindowSchema = z
  .object({ since: daySchema, until: daySchema })
  .refine(
    ({ since, until }) => Date.parse(since) < Date.parse(until) && Date.parse(until) - Date.parse(since) <= 90 * DAY_MS,
    { message: 'Choose a valid date window of up to 90 days. “Before” excludes that date.', path: ['until'] }
  )
export type DateWindow = z.infer<typeof dateWindowSchema>
